import React from 'react';
import domtoimage from "dom-to-image";

class ImageManager {

    constructor() {
        this.images = [];
    }

    getDataUrl(url) {
        var image = new Image();

        return new Promise(function (resolve) {
            
            image.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = this.width;
                canvas.height = this.height;
                canvas.getContext('2d').drawImage(this, 0, 0);
                resolve({ imageUrl: canvas.toDataURL('image/png'), w: this.width, h: this.height, src:this.rawSrc });
            };

            image.src = url;
            image.rawSrc = url;
        }.bind(this));
    }
    
    getDataUrls(imagePaths) {
        this.images = [];
        var imagesLoaded = 0;

        return new Promise(function (resolve) {

            for (var i = 0; i < imagePaths.length; i++) {
                var path = imagePaths[i];

                this.getDataUrl(path).then(function (img) {
                    this.images[img.src] = img
                    imagesLoaded++;
                    if (imagesLoaded == imagePaths.length) {
                        resolve(this.images)
                    }
                }.bind(this));
            }
        }.bind(this));
    }
}

export default ImageManager;

